import React, { useEffect, useState } from "react";
import AXIOSCONFIGMETHOD from "../../../../components/apiCall/axiosConfig";
import { webServiceUrl } from "../../../../components/apiCall/webserviceurl";
import Loading from "../../../../components/common/Loading";

function Learning_Outcomes({ program_id }) {
  const [technical, setTechnical] = useState([]);
  const [softSkills, setsoftSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const local = localStorage.getItem("school_code");
  const getData = async () => {
    try {
      setLoading(true);
      const resp = await AXIOSCONFIGMETHOD(
        "POST",
        webServiceUrl.learning_outcomes,
        {
          program_id: local,
        },
      );
      // console.log(resp);
      setTechnical(resp?.technical || []);
      setsoftSkills(resp?.softskills || []);
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {loading ? (
        <div className="py-5" style={{ height: "20vh" }}>
          <Loading />
        </div>
      ) : (
        <>
          <section className="max-w-7xl mx-auto px-6 py-12">
            <p className="subHeading my-3">Technical Skills Acquired</p>

            {technical?.map((item) => (
              <>
                <div className="heading my-3">✅ {item?.skill_title}</div>
                <div
                  className="prose"
                  dangerouslySetInnerHTML={{
                    __html: item?.detail_text?.trim() || "",
                  }}
                />
              </>
            ))}
            <p className="subHeading my-3">Soft Skills Developed</p>
            {softSkills?.map((item) => (
              <>
                <div className="heading my-3">✅ {item?.skill_title}</div>
                <div
                  className="prose"
                  dangerouslySetInnerHTML={{
                    __html: item?.detail_text?.trim() || "",
                  }}
                />
              </>
            ))}
          </section>
        </>
      )}
    </div>
  );
}

export default Learning_Outcomes;
